import { render, staticRenderFns } from "./SchoolyearPlanningActivitiesAddEdit.vue?vue&type=template&id=5d5bd6a5&scoped=true"
import script from "./SchoolyearPlanningActivitiesAddEdit.vue?vue&type=script&lang=js"
export * from "./SchoolyearPlanningActivitiesAddEdit.vue?vue&type=script&lang=js"
import style0 from "./SchoolyearPlanningActivitiesAddEdit.vue?vue&type=style&index=0&id=5d5bd6a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5bd6a5",
  null
  
)

export default component.exports